<template>
    <transition
        leave-active-class="transition duration-200 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
    >
        <div
            v-if="show"
            class="flex items-start gap-3 border-b border-new-amber-200 bg-new-amber-50 px-4 py-3"
        >
            <Info class="size-5 shrink-0 text-new-amber-600 mt-0.5" />

            <div class="flex-1 text-sm">
                <p class="font-medium text-new-amber-900">
                    {{ title }}
                </p>
                <p v-if="$slots.default" class="text-new-amber-700 mt-0.5">
                    <slot />
                </p>
            </div>

            <Button
                v-if="dismissible"
                variant="ghost"
                size="icon"
                class="size-8 shrink-0 text-new-amber-700 hover:text-new-amber-900 hover:bg-new-amber-100"
                aria-label="Dismiss"
                @click="emit('dismiss')"
            >
                <X class="size-4" />
            </Button>
        </div>
    </transition>
</template>

<script setup lang="ts">
import { Info, X } from 'lucide-vue-next'
import { Button } from '@/components/ui/button'

defineProps<{
    title: string
    show: boolean
    dismissible?: boolean
}>()

const emit = defineEmits<{
    dismiss: []
}>()
</script>
